/* eslint-disable no-async-promise-executor */
import ToktokdocLib from '@saas/lib/toktokdoc-lib/web'
import axios from 'axios'
import Either from '../types/either'

/**
 *
 *
 * @param {*} src
 * @returns
 */
export const getSecureVideo = async (src: string) => {
    try {
        const parseToken = await ToktokdocLib.Utils.getSessionToken()
        const response = await fetch(src, {
            method: 'GET',
            headers: {
                'X-Session-Token': parseToken,
            },
        })
        let token
        if (response.status === 200) {
            token = (await response.json()).token
            return token ? `${src}/${token}` : 'videoStillProcessing'
        }
        throw new Error(`Failed download ${response.status}`)
    } catch (error: any) {
        const message = `[getSecureVideo] Error catched while fetching video | status : ${error.status}`
        console.error(message)
        return new Error('Impossible de récuperer la video')
    }
}

export const getSecureImage = async (src: string) => {
    try {
        const token = await ToktokdocLib.Utils.getSessionToken()
        const data = await fetch(src, {
            method: 'GET',
            headers: {
                'X-Session-Token': token,
            },
        })
        if (data.status !== 200) throw new Error(`Failed download ${data.status}`)

        const responseBlob = await data.blob()
        const urlObj = URL.createObjectURL(responseBlob)
        return urlObj
    } catch (error: any) {
        const message = `[getSecureVideo] Error catched while fetching video | status : ${error.status}`
        console.error(message)
        return new Error('Impossible de récuperer la video')
    }
}

export const getSecureDocument = async (url: string) => {
    const token = await ToktokdocLib.Utils.getSessionToken()
    try {
        const result = await fetch(url, {
            method: 'GET',
            headers: {
                'X-Session-Token': token,
            },
        })
        if (result.status !== 200) throw new Error(`Failed download ${result.status}`)

        const responseBlob = await result.blob()
        const urlObj = URL.createObjectURL(responseBlob)
        return urlObj
    } catch (error: any) {
        const message = `[getSecureDocument] Error catched while fetching document | status : ${error.status}`
        console.error(message)
        return new Error('Impossible de récupérer le document')
    }
}

export const downloadZipFile = async (url: string) => {
    const token = await ToktokdocLib.Utils.getSessionToken()
    try {
        const result = await axios.get(`${url}`, {
            headers: {
                'X-Session-Token': token,
            },
            responseType: 'blob',
        })
        const fileUrl = URL.createObjectURL(result.data)
        const a = document.createElement('A')
        a.setAttribute('href', fileUrl)
        a.setAttribute('download', result.headers['content-disposition'].match(/filename="([^"]+)"/)[1])
        document.body.appendChild(a)
        a.click()
        a.remove()
        return result.data
    } catch (error: any) {
        const message = `[getSecureDocument] Error catched while fetching document | status : ${error.status}`
        console.error(message)
        return new Error('Impossible de récupérer le document')
    }
}

export const getRequiredExpertInChargeLabelFromPatient = async (patient: any) => {
    let requiredExpertInChargeLabel: string | null = null
    try {
        if (patient.requiredExpertInCharge) {
            const token = await ToktokdocLib.Utils.getSessionToken()
            const req = await axios.get(
                `${window._env_.REACT_APP_HDS_HOST}/user/infos/${patient.requiredExpertInCharge.objectId}`,
                {
                    headers: {
                        'X-Session-Token': token,
                    },
                },
            )
            const { data } = req
            requiredExpertInChargeLabel = `${(data.prefix || 'DR').toUpperCase()}. ${data.lastName.toUpperCase()} ${
                data.firstName
            } ${data.rpps ? `(${data.rpps})` : ''}`
        } else if (patient.requiredExpertInChargeRpps === -1) requiredExpertInChargeLabel = 'Aucun'
        else if (patient.requiredExpertInChargeLabel) requiredExpertInChargeLabel = patient.requiredExpertInChargeLabel
    } catch (error) {
        console.log('[HDSJS]-[getRequiredExpertInChargeLabel] error : ', error)
    }

    return requiredExpertInChargeLabel
}

/**
 * @async
 * @description check if the required expert is in the demo HCS to be able to start demos
 * @param {String} requiredExpertId
 * @returns {Promise}
 */
export const checkInDemoHcs = async (requiredExpertId: any) => {
    try {
        const token = await ToktokdocLib.Utils.getSessionToken()
        return fetch(`${window._env_.REACT_APP_HDS_HOST}/manageRequiredExptToDemoHcs/${requiredExpertId}`, {
            method: 'POST',
            headers: {
                'X-Session-Token': token,
            },
        })
    } catch (error) {
        // @ts-expect-error TS(2769) FIXME: No overload matches this call.
        throw new Error(error)
    }
}

/**
 * @description simulate recieving a new picture in a demo TLC
 * @param {String} consultationId
 */
export const simulatePicture = async (consultationId: any) => {
    try {
        const token = await ToktokdocLib.Utils.getSessionToken()
        return fetch(`${window._env_.REACT_APP_HDS_HOST}/simulatePictureTLC/${consultationId}`, {
            method: 'POST',
            headers: {
                'X-Session-Token': token,
            },
        })
    } catch (error) {
        console.log('error : ', error)
        // @ts-expect-error TS(2769) FIXME: No overload matches this call.
        return new Error(error)
    }
}

/**
 * @description simulate recieving a new document in a demo TLC
 * @param {String} consultationId
 */
export const simulateDocument = async (consultationId: any) => {
    try {
        const token = await ToktokdocLib.Utils.getSessionToken()
        return fetch(`${window._env_.REACT_APP_HDS_HOST}/simulateDocumentTLC/${consultationId}`, {
            method: 'POST',
            headers: {
                'X-Session-Token': token,
            },
        })
    } catch (error) {
        console.log('error : ', error)
        // @ts-expect-error TS(2769) FIXME: No overload matches this call.
        return new Error(error)
    }
}

/**
 * @description will ask a password reset mail
 * @param {String} email
 */
export const requestPasswordReset = async (email: string) => {
    try {
        const response = await fetch(`${window._env_.REACT_APP_HDS_HOST}/login/passwordReset`, {
            method: 'POST',
            body: JSON.stringify({
                email,
            }),
            headers: {
                'Content-Type': 'application/json',
            },
        })
        return Either.right(response.body)
    } catch (error) {
        if (error instanceof Error) {
            return Either.left(error)
        }
        return Either.left(new Error('Something went wrong'))
    }
}

const getHdsRequester = () => {
    const sessionToken = localStorage.getItem('sessionToken')

    const requester = axios.create({
        baseURL: window._env_.REACT_APP_HDS_HOST,
        headers: {
            'X-Session-Token': sessionToken,
        },
        withCredentials: true,
    })

    return requester
}

export const hdsRequester = getHdsRequester()
